import { JourneyRoute } from '@cash-web/shared-journey-util-main'

import { ShareTextToast, ShareTextToastData } from './ShareTextToast'

// Shared action client routes are for cross-domain, non-view client routes
export const sharedActionClientRoutes = [
  {
    id: 'share-text',
    trackingName: 'Share Text',
    path: 'dl/share-text',
    target: 'toast',
    Component: ShareTextToast,
    loader: async ({ request }): Promise<ShareTextToastData> => {
      const searchParams = new URL(request.url).searchParams
      const text = searchParams.get('text')
      const itemType = searchParams.get('item_type')

      if (!text) {
        return { result: 'failure' }
      }

      try {
        await navigator.clipboard.writeText(text)
        return { result: itemType === 'url' ? 'copy-link' : 'copy-text' }
      } catch {
        return { result: 'failure' }
      }
    },
  },
] as const satisfies JourneyRoute[]
